export default "__VITE_ASSET__66661077__"